import { keyframes } from "goober";

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-48px); }
`;

const scrollSmall = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-18px); }
`;

export function WavyLine({
  opacity = 0.1,
  size,
  color = "var(--text-primary)",
}: {
  opacity?: number;
  size?: number;
  color?: string;
} = {}) {
  if (size) {
    const wave =
      "M0,6 C1.5,1.5 3,1.5 4.5,6 C6,10.5 7.5,10.5 9,6 C10.5,1.5 12,1.5 13.5,6 C15,10.5 16.5,10.5 18,6";
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        style={{ overflow: "hidden", opacity }}
      >
        <g style={{ animation: `${scrollSmall} 2s linear infinite` }}>
          <path
            d={wave}
            fill="none"
            stroke={color}
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            d={wave}
            fill="none"
            stroke={color}
            strokeWidth="1"
            strokeLinecap="round"
            transform="translate(18, 0)"
          />
        </g>
      </svg>
    );
  }

  const wave =
    "M0,12 C4,2 8,2 12,12 C16,22 20,22 24,12 C28,2 32,2 36,12 C40,22 44,22 48,12";

  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      style={{ overflow: "hidden", opacity }}
    >
      <g style={{ animation: `${scroll} 2s linear infinite` }}>
        <path
          d={wave}
          fill="none"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d={wave}
          fill="none"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          transform="translate(48, 0)"
        />
      </g>
    </svg>
  );
}
